export default class ForgotPasswordRequest {
    public username: string;

    constructor(username: string) {
        this.username = username;
    }
}